import {Box, Typography} from '@mui/material';
import {useTranslation} from 'react-i18next';

const STARS = 4.8;

const PaymentLinkStars = () => {
  const {t} = useTranslation();

  const stars = Array.from({length: 5}, (_, idx) =>
    idx < 4
      ? {src: '/assets/icons/gray-star.svg', alt: 'star'}
      : {src: '/assets/icons/gray-star-incomplete.svg', alt: 'half-star'},
  );

  return (
    <Box className="payment-link-footer-stars-container">
      <Box className="payment-link-footer-stars">
        {stars.map((star, idx) => (
          <Box
            key={idx}
            component="img"
            src={star.src}
            alt={star.alt}
          />
        ))}
      </Box>
      <Typography className="payment-link-footer-text payment-link-stars-text">
        {t('payment_link.stars', {stars: STARS})}
      </Typography>
    </Box>
  );
};

export default PaymentLinkStars;
